import React, {useEffect, useRef, useState} from 'react'
import {withRouter} from "../../../helpers/withRouter";
import {connect} from "react-redux";


const EditorSuggestionDropDown = (props) => {
	const [direction] = useState(props.direction)
	const {elementRef, width} = useElementWidth();
	const [keys, setKeys] = useState({up: false, down: false, tab: false, esc: false, enter: false})
	const [options, setOptions] = useState(props.options)
	
	
	useEffect(() => {
		const editorElement = document.getElementsByClassName('ProseMirror toastui-editor-contents')[0]
		editorElement?.addEventListener('scroll', scrollListener)
		return () => {
			document.removeEventListener("scroll", scrollListener)
			editorElement?.removeEventListener("scroll", scrollListener)
			document.removeEventListener("keydown", keyListener)
			document.removeEventListener("click", clickHandler)
		}
	}, []);
	
	useEffect(() => {
		if (elementRef.current) {
			elementRef.current.selectedIndex = 0
			elementRef.current.focus()
		}
	}, [elementRef])
	
	useEffect(() => {
		if (props.show) {
			document.addEventListener("keydown", keyListener)
			document.addEventListener("scroll", scrollListener)
			document.addEventListener('click', clickHandler)
		} else {
			document.removeEventListener("keydown", keyListener)
			document.removeEventListener("scroll", scrollListener)
			document.removeEventListener("click", clickHandler)
		}
	}, [props.show]);
	
	useEffect(() => {
		if (direction && direction !== props.direction) {
			Esc()
		}
	}, [props.direction]);
	
	useEffect(() => {
		setOptions(props.options)
	}, [props.options]);
	
	useEffect(() => {
		if (checkTrue()) {
			if (keys.up) {
				Up()
			} else if (keys.down) {
				Down()
			} else if (keys.esc) {
				Esc()
			} else if (keys.enter) {
				Enter()
			}
			resetToInitial()
		}
	}, [keys]);
	
	const checkTrue = () => {
		return Object.values(keys).some(val => val)
	}
	
	const scrollListener = (event) => {
		Esc()
	}
	
	const clickHandler = (event) => {
		if (elementRef.current && !elementRef.current.contains(event.target)) {
			Esc()
		}
	}
	
	const keyListener = (event) => {
		if (event?.code === "ArrowDown" && event?.keyCode === 40 && event?.type === "keydown") {
			event.preventDefault();
			setKeys((prevState) => ({...prevState, down: true}))
		}
		if (event?.key === "ArrowUp" && event?.keyCode === 38 && event?.type === "keydown") {
			event.preventDefault();
			setKeys((prevState) => ({...prevState, up: true}))
		}
		if (event?.key === "Escape" && event?.keyCode === 27 && event?.type === "keydown") {
			event.preventDefault();
			setKeys((prevState) => ({...prevState, esc: true}))
		}
		if (event?.key === "Enter" && event?.keyCode === 13 && event?.type === "keydown") {
			event.preventDefault();
			setKeys((prevState) => ({...prevState, enter: true}))
		}
	}
	
	const getCurrentSelectedIndex = () => {
		return elementRef.current.selectedIndex
	}
	
	const lastOptionIndex = () => {
		return options.length - 1
	}
	
	const Up = () => {
		let current = getCurrentSelectedIndex()
		if (current > 0) {
			elementRef.current.selectedIndex -= 1
		} else {
			elementRef.current.selectedIndex = lastOptionIndex()
		}
	}
	const Down = () => {
		let current = getCurrentSelectedIndex()
		if (current < lastOptionIndex()) {
			elementRef.current.selectedIndex += 1
		} else {
			elementRef.current.selectedIndex = 0
		}
	}
	const Esc = () => {
		props.close()
	}
	const Enter = (index = elementRef.current.selectedIndex) => {
		props.replacement(props.text, props.options?.[index]?.name)
		Esc()
	}
	
	const resetToInitial = () => {
		setTimeout(() => {
			setKeys({up: false, down: false, tab: false, esc: false, enter: false})
		}, 50)
	}
	
	const styles = () => {
		let style = {
			position: 'absolute',
			top: props.position.top,
			background: 'red',
			maxWidth: '250px',
			zIndex: 20
		}
		if (direction === 'rtl')
			style = {...style, left: props.position.left - width}
		else
			style = {...style, left: props.position.left}
		return style
	}
	
	return <>
		{props.show &&
			<span style={{...styles()}}>
				<select className="form-select"
				        size="3"
				        ref={elementRef}
				>
					{props?.options?.map((item, index) => {
						return <option key={item.name}
						               value={item.name}
						               onClick={() => Enter(index)}
						> {item.name} </option>
					})}
				</select>
			</span>}
	</>
}


const useElementWidth = () => {
	const [width, setWidth] = useState(0);
	const elementRef = useRef(null);
	
	const getElementSize = () => {
		if (elementRef.current) {
			const width = elementRef.current.offsetWidth; // Width including padding and border
			const height = elementRef.current.offsetHeight; // Height including padding and border
			setWidth(width)
		}
	};
	
	useEffect(() => {
		getElementSize();
	}, []);
	
	// Use a MutationObserver to track changes in the content of the element
	useEffect(() => {
		const observer = new MutationObserver(getElementSize);
		// Configure the observer to watch for changes in the content of the element
		const config = {childList: true, subtree: true};
		if (elementRef.current) {
			// Start observing the target node for configured mutations
			observer.observe(elementRef.current, config);
		}
		// Clean up the observer when the component unmounts
		return () => {
			observer.disconnect();
		};
	}, [elementRef]);
	
	return {elementRef, width};
};

const mapStateToProps = state => {
	const language = state.LangReducer.language;
	return {language};
};

export default connect(mapStateToProps)(withRouter(EditorSuggestionDropDown));